import {
  RESTAURANT_SEARCH_LOADING,
  RESTAURANT_SEARCH_IDLE,
  RESTAURANT_SEARCH_CHANGE,
  RESTAURANT_SEARCH_UPDATE,
  RESTAURANT_SEARCH_FORM_UPDATE,
  RESTAURANT_SEARCH_RESET,
  RESTAURANT_CATEGORIES_SAVE,
  RESTAURANT_SEARCH_FORM_INIT,
} from "../actions/search/types";

const RestaurantSearchFormInitial = {
  country: "",
  lat: 0,
  lng: 0,
  radius: 0,
  category: "",
  price_quartile: "",
  aggregate_score: 0,
  page: 1,
  page_size: 12,
  order_by: "score",
  destinationObj: {
    destination_code: ["lvl1___3340"],
    destination_meta: {
      id: 3340,
      type: "lvl1",
      destination: "Dubai-United Arab Emirates",
      score: 1,
      label: "Dubai - United Arab Emirates",
      value: "Dubai - United Arab Emirates",
      location_type: "destination",
    },
  },
};
export const RestaurantSearchForm = (
  state = RestaurantSearchFormInitial,
  action
) => {
  switch (action.type) {
    case RESTAURANT_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case RESTAURANT_SEARCH_FORM_INIT: {
      return RestaurantSearchFormInitial;
    }
    default:
      return state;
  }
};

const RestaurantCategoriesInitial = {
  categories: [],
  count: 0,
};
export const RestaurantCategories = (
  state = RestaurantCategoriesInitial,
  action
) => {
  switch (action.type) {
    case RESTAURANT_CATEGORIES_SAVE: {
      const { data } = action;
      return data;
    }
    default:
      return state;
  }
};

const RestaurantSearchReducerInitial = {
  restaurants: [],
  loading: false,
  failed: false,
  count: null,
  previous: null,
  next: null,
};
export const RestaurantSearchReducer = (
  state = RestaurantSearchReducerInitial,
  action
) => {
  switch (action.type) {
    case RESTAURANT_SEARCH_LOADING: {
      return { ...state, loading: true };
    }
    case RESTAURANT_SEARCH_IDLE: {
      return { ...state, loading: false };
    }
    case RESTAURANT_SEARCH_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case RESTAURANT_SEARCH_UPDATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    case RESTAURANT_SEARCH_RESET: {
      return RestaurantSearchReducerInitial;
    }
    default:
      return state;
  }
};
